import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import Home from '../pages/HomeCyan.vue'
import TicketBooking from '@/pages/TicketBooking.vue'
import TermsAndCondition from '../pages/TermsAndCondition.vue'
import ParkRules from '../pages/ParkRules.vue'
import Login from '../pages/LoginCyan.vue'
import LoginOtp from '../pages/LoginOtp.vue'
import DressCode from '@/pages/DressCode.vue'
import SchoolTrip from '@/pages/SchoolTrip.vue'
import Faqs from '@/pages/Faqs.vue'
import FamilyRides from '@/pages/FamilyRides.vue'
import ThrillRides from '@/pages/ThrillRides.vue'
import KidsRides from '@/pages/KidsRides.vue'
import RescheduleVisit from '@/pages/RescheduleVisit.vue'
import OpeningHours from '@/pages/OpeningHours.vue'
import TransactionSuccess from '@/pages/TransactionSuccess.vue'
import TransactionFailed from '@/pages/TransactionFailed.vue'
import WorkingHours from '@/pages/Working-Hours.vue'
import PrivacyPolicy from '@/pages/PrivacyPolicy.vue'
const routes = [
  { path: '/', component: Home },
  { path: '/tickets', component: TicketBooking },
  { path: '/terms-and-condition', component: TermsAndCondition },
  { path: '/park-rules', component: ParkRules },
  { path: '/login', component: Login },
  { path: '/dress-code', component: DressCode },
  { path: '/school-trip', component: SchoolTrip },
  { path: '/faqs', component: Faqs },
  { path: '/rides/family', component: FamilyRides },
  { path: '/rides/thrill', component: ThrillRides },
  { path: '/rides/kids', component: KidsRides },
  { path: '/login-otp', name: 'LoginOtp', component: LoginOtp },
  { path: '/reschedule', component: RescheduleVisit },
  { path: '/opening-hours', component: OpeningHours },
  { path: '/transaction_success', component: TransactionSuccess },
  { path: '/transaction_failed', component: TransactionFailed },
  { path: '/working-hours', component: WorkingHours },
  { path: '/privacy-policy', component: PrivacyPolicy }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard to prevent logged-in users from accessing login page
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  // If user is trying to access login page and is already logged in, redirect to home
  if (to.path === '/login' && userStore.isLoggedIn()) {
    next('/')
    return
  }

  next()
})

export default router